import { Component } from '@angular/core';

@Component({
  selector: 'app-card-details-claim',
  templateUrl: './card-details-claim.component.html',
  styleUrls: ['./card-details-claim.component.scss'],
})
export class CardClaimDetailComponent {}
